import { useEffect, useState } from "react"
import Swal from "sweetalert2"
import { Workout } from "./application/domain/workout"
import { useParams } from "react-router-dom"
import { FaPlus } from "react-icons/fa"
import { GlobalStyle, Container, ListView, FabButton, CustomModal, Description, HeaderDash, Wrapper, TopMenu } from "../../common"
import { Load } from "../../common/load/load"
import { FormCreateWorkout } from "./from-create-workout/form-create-workout"

import { WorkoutItem } from "./workout-item"
import { WorkoutController } from "./infra/controller/workout.controller"
import { DrillCode } from "../drills/application/domain/drill-code"
import { ResolveDrillCodeUseCase } from "../drills/application/usecases/actions/resolve-drill-code.usecase"

export const WorkoutsUi = () => {
    const [workouts, setWorkouts] = useState<Workout[]>([])
    const [_, setDrillName] = useState<string>("")
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [load, setLoad] = useState(false)
    const [drillCode, setDrillCode] = useState<DrillCode>(DrillCode.COLOR_DASH)
    const { drillId } = useParams<{ drillId: string }>()

    useEffect(() => {
        const fetchWorkouts = async () => {
            WorkoutController.listWorkouts({
                drillId,
                setWorkouts,
                setDrillName,
                setLoad
            });
        }
        fetchWorkouts();
        ResolveDrillCodeUseCase.execute(drillId).then(setDrillCode);
    }, []);

    const submitCreateWorkout = async (name: string): Promise<void> => {
        await WorkoutController.create({
            drillId,
            name,
            setLoad,
            setWorkouts,
            setIsModalOpen
        });
    }

    const handleDeleteWorkout = async (id: string): Promise<void> => {
        const result = await Swal.fire({
            title: "Excluir treino",
            text: "Deseja realmente excluir este treino?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        });
        if (!result.isConfirmed) {
            return;
        }
        await WorkoutController.deleteWorkout({
            workoutId: id,
            setWorkouts,
            setLoad,
        });
    }

    return (
        <>
            <GlobalStyle />
            {load && <Load />}
            <Container>
            <TopMenu/>
                <Wrapper>
                    <HeaderDash title="Treinos" description="Gerencie os treinos deste drill" />
                    {!workouts?.length && (<Description align="center">Nenhum treino encontrado</Description>)}

                    <ListView
                        top="30px">
                        {workouts.map((workout) => (
                            <>
                                <WorkoutItem
                                    id={workout.id}
                                    onDelete={() => handleDeleteWorkout(workout.id)}
                                    key={workout.id}
                                    name={workout.name}
                                    drillCode={drillCode}
                                />
                            </>

                        ))}
                    </ListView>

                    <FabButton
                        icon={<FaPlus />}
                        position="bottom-right"
                        size={56}
                        onClick={() => setIsModalOpen(true)}
                    />

                    <CustomModal
                        isOpen={isModalOpen}
                        onRequestClose={() => setIsModalOpen(false)}
                        contentLabel="Adicionar Treino"
                    >
                        <FormCreateWorkout onSubmit={submitCreateWorkout} loading={load} />
                    </CustomModal>

                </Wrapper>
            </Container>
        </>
    )
}